import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  values: {
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 45,
  },
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  spaceHeader: {
    marginTop: 30,
  },
  paymentText: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 18,
    maxWidth: 200,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  boldText: {
    fontWeight: 'bold',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 50,
  },
  debts: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 19,
    color: 'black',
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textFilter: {
    marginRight: 10,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  containerCard: {
    marginVertical: 30,
  },
  message: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 20,
    color: 'black',
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  paragraph: {
    fontSize: 10,
    fontWeight: '200',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  phone: {
    fontSize: 16,
    fontWeight: '400',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  containerQuestions: {
    padding: 15,
    marginBottom: 20,
    backgroundColor: 'white',
    color: 'black',
  },

  containerModal: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
  containerFilter2: {
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 16,
    paddingVertical: 15,
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxHeight: '80%',
    minHeight: 200,
  },
  containerButton: {
    paddingHorizontal: 45,
    marginTop: 20,
    alignItems: 'center',
  },

  paymentBox: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 15,
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    marginHorizontal: 20,
  },

  paymentMethod: {
    fontSize: 16,
    color: 'black',
  },

  changeButton: {
    color: Colors.RedPallete.red,
    padding: 6,
  },

  changeButtonText: {
    color: Colors.RedPallete.red,
    fontSize: 14,
    fontWeight: '600',
  },

  summaryBox: {
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    padding: 15,
    marginHorizontal: 20,
    marginBottom: 30,
  },

  summaryLine: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 6,
  },

  label: {
    fontSize: 14,
    color: 'black',
  },

  value: {
    fontSize: 14,
    color: 'black',
  },

  buttonWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: 'center',
    paddingBottom: 20,
    paddingTop: 10,
    backgroundColor: 'transparent',
  },

  buttonBackground: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'white',
    zIndex: -1,
    borderTopWidth: 1,
    borderColor: '#ddd',
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8,
  },
  paymentRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#eee',
    padding: 12,
    borderRadius: 8,
    marginBottom: 15,
  },
  selectedMethod: {
    fontSize: 14,
    color: '#111',
  },
  boletoSection: {
    marginHorizontal: 20,
    marginBottom: 16,
  },
  boletoList: {
    marginTop: 6,
  },
  boletoLineCard: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
  },
  boletoLineTitle: {
    fontWeight: '600',
    fontSize: 14,
    color: '#222',
    marginBottom: 4,
  },
  boletoLineText: {
    fontSize: 14,
    color: '#444',
    marginBottom: 12,
    lineHeight: 20,
  },
  boletoActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  boletoWarningText: {
    fontSize: 12,
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'justify',
    marginTop: 6,
    marginHorizontal: 4,
  },
  debtCard: {
    backgroundColor: '#f8f8f8',
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
  },
  debtTitle: {
    fontWeight: '600',
    fontSize: 14,
    color: '#222',
  },
  debtValue: {
    fontSize: 14,
    color: '#555',
  },
  row: {
    fontSize: 14,
    color: '#333',
    marginBottom: 4,
  },
  total: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000',
    marginTop: 8,
  },
  fixedButtonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: '#ddd',
  },
  payButton: {
    backgroundColor: '#007bff',
    padding: 14,
    borderRadius: 8,
    alignItems: 'center',
  },
  payButtonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '85%',
    maxHeight: '80%',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 20,
    alignItems: 'stretch',
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
    textAlign: 'center',
    color: '#333',
  },
  methodItem: {
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F9F9F9',
    borderRadius: 12,
    padding: 6,
    marginBottom: 12,
    elevation: 2,
  },
  pixCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F9F9F9',
    borderRadius: 12,
    padding: 6,
    paddingVertical: 17,
    marginBottom: 12,
    elevation: 2,
  },
  cardImage: {
    width: 40,
    height: 25,
    resizeMode: 'contain',
    marginRight: 16,
  },
  cardInfo: {
    flex: 1,
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#333',
  },
  cardNumber: {
    color: '#666',
    fontSize: 14,
    marginTop: 4,
  },
  listContent: {
    paddingBottom: 100,
  },
  boletoOption: {
    padding: 14,
    borderRadius: 12,
    backgroundColor: '#fafafa',
    borderWidth: 1,
    borderColor: '#eee',
    marginBottom: 12,
  },
  boletoOptionDescription: {
    fontSize: 12,
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 4,
  },
  successModalContent: {
    backgroundColor: '#fff',
    margin: 32,
    padding: 24,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%',
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    color: '#666',
    padding: 10,
    marginBottom: 12,
    backgroundColor: '#fff',
  },
  // NOVOS ESTILOS PARA MODAL DE CUSTOMER
  customerModalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 20,
  },
  customerModalContent: {
    width: '100%',
    maxWidth: 400,
    maxHeight: '85%',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 20,
  },
});